<template>
    <div>
        <div class="bg-primary-100 overflow-y-hidden flex flex-col items-center justify-center lg:justify-between">
            <div class="py-12">
                <div class="flex flex-wrap items-center justify-center bg-primary-400 px-2 rounded-lg">
                    <span class="text-lg text-white font-bold mr-2 my-2">{{ person.name }} on</span>
                    <div class="relative w-auto my-2">
                        <select v-model="person.session" class="block appearance-none w-full bg-primary-300 border border-2 border-primary-300 px-2 py-1 pr-8 rounded leading-tight focus:outline-none text-white">
                            <option v-for="s of Object.keys(person.sessions)"
                                    :value="s"
                            >{{ new Date(s * 1000) | sessionDate }}</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-white">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container flex justify-center px-4">
                <div class="w-full xl:w-9/12">
                    <div v-if="!error" class="container-icons flex justify-around">
                        <div v-for="competency in Object.values(competencies)"
                             class="icon-wrapper flex items-end">
                            <div @click="openFeedbackModal(competency)"
                                 class="icon icon-tail border-1 md:border-2 border-white cursor-pointer"
                                 :style="{bottom: getCompetencyHeight(competency)}">
                                <img :src="getCompetencyIcon(competency)" :alt="competency['name'] | trans">
                            </div>
                        </div>
                    </div>
                    <div v-else class="flex justify-center py-12">
                        <h3 class="text-xl sm:text-2xl font-bold text-center">{{ error }}</h3>
                    </div>
                </div>
            </div>
        </div>

        <score-feedback-modal
            v-if="feedbackModal"
            :title="modal.title"
            :description="modal.description"
            :icon="modal.icon"
            :score="modal.score"
            @close="feedbackModal = false" />
    </div>
</template>

<script>
    import ScoreFeedbackModal from '../shared/ScoreFeedbackModal';

    export default {
        components: {
            ScoreFeedbackModal,
        },
        props: {
            person: {
                type: Object,
                required: true
            },
            competencies: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                feedbackModal: false,
                error: null,
                modal: {
                    title: '',
                    description: '',
                    icon: '',
                    score: 0,
                },
            }
        },
        watch: {
            'person.session': {
                immediate: true,
                handler(session) {
                    if (!Object.keys(this.person.sessions[session].score).length) {
                        this.error = 'No scores for this session';
                    } else {
                        this.error = null;
                    }
                }
            }
        },
        methods: {
            getCompetencyIcon(competency) {
                let name = competency.name.en.replace('/', '-');
                return `assets/img/competencies/${name}.svg`;
            },
            getCompetencyHeight(competency) {
                return String(this.getCompetencyScore(competency) * 20) + '%';
            },
            getCompetencyScore(competency) {
                return this.person.sessions[this.person.session].score[competency.id] || 0;
            },
            openFeedbackModal(competency) {
                this.modal.title = this.$options.filters.trans(competency.name);
                this.modal.description = this.$options.filters.trans(competency.description);
                this.modal.icon = this.getCompetencyIcon(competency);
                this.modal.score = this.getCompetencyScore(competency);
                this.feedbackModal = true;
            },
        },
    }
</script>
